import { AuthJwt } from '@imaginelearning/web-auth';
import { isEmpty, isEqual } from 'lodash-es';
import { of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import http from '@imaginelearning/httprx';
import * as Cookies from 'js-cookie';

var Urls = /*#__PURE__*/function () {
  function Urls() {}
  Urls.normalizeEnvironment = function normalizeEnvironment(environment) {
    return /dev/gi.test(environment) || /test/gi.test(environment) ? 'test' : /prod/gi.test(environment) ? 'prod' : /rc/gi.test(environment) ? 'rc' : environment;
  };
  Urls.replaceEnv = function replaceEnv(url, environment) {
    var env = Urls.normalizeEnvironment(environment);
    var regex = new RegExp(/(https:\/\/)/gi);
    return env === 'prod' ? url : url.replace(regex, "$1" + env);
  };
  Urls.get = function get(environment) {
    var _Urls$urlsByEnvironme, _Urls$urlsByEnvironme2, _Urls$urlsByEnvironme3, _Urls$urlsByEnvironme4;
    var env = Urls.normalizeEnvironment(window['IL_PORTAL_ENV'] ? window['IL_PORTAL_ENV'].name : environment || Urls.environment);
    return {
      environment: env,
      readerApiUrl: Urls.replaceEnv(Urls.readerApiUrl, env) + '/v' + Urls.apiVersion.reader,
      apiUrl: Urls.replaceEnv(Urls.apiUrl, env) + '/v' + Urls.apiVersion.api,
      unVersionedApiUrl: Urls.replaceEnv(Urls.apiUrl, env),
      artifactApiUrl: Urls.replaceEnv(Urls.apiUrl, env) + '/v' + Urls.apiVersion.artifactApi,
      reportApiUrl: Urls.replaceEnv(Urls.apiUrl, env) + '/report/v' + Urls.apiVersion.report,
      loginApiUrl: Urls.replaceEnv(Urls.loginApiUrl, env),
      unVersionedManagementApiUrl: Urls.replaceEnv(Urls.managementApiUrl, env),
      managementApiUrl: Urls.replaceEnv(Urls.managementApiUrl, env) + '/v' + Urls.apiVersion.manager,
      sequencerApiUrl: Urls.replaceEnv(Urls.sequencerApiUrl, env) + '/v' + Urls.apiVersion.sequencer,
      reportsApiUrl: Urls.replaceEnv(Urls.reportsApiUrl, env) + '/v' + Urls.apiVersion.reports,
      singleSignOnApiUrl: Urls.replaceEnv(Urls.singleSignOnApiUrl, env) + '/v' + Urls.apiVersion.singleSignOn,
      importApiUrl: Urls.replaceEnv(Urls.importApiUrl, env) + '/',
      directusApiUrl: Urls.directusApiUrl + '/api/' + Urls.apiVersion.directus,
      loggerApiUrl: Urls.replaceEnv(Urls.loggerApiUrl, env) + '/v' + Urls.apiVersion.logger,
      unityLaunchUrl: Urls.unityLaunchUrl,
      html5ClientLaunchUrl: Urls.replaceEnv(Urls.html5ClientLaunchUrl, env),
      newHtml5ClientLaunchUrl: Urls.replaceEnv(Urls.newHtml5ClientLaunchUrl, env),
      portalUrl: Urls.portalUrl,
      loginUrl: Urls.replaceEnv(Urls.loginUrl, env),
      galileoUrl: Urls.urlsByEnvironment[env] && Urls.urlsByEnvironment[env].galileoUrl || Urls.urlsByEnvironment[Urls.environment].galileoUrl,
      readingHeartbeatApiUrl: Urls.replaceEnv(Urls.readingHeartbeatApiUrl, env) + '/v' + Urls.apiVersion.readingHeartbeat + '/session/',
      learnosityApiUrl: Urls.replaceEnv(Urls.learnosityApiUrl, env) + '/v' + Urls.apiVersion.learnosity + '/Learnosity/',
      readingApiUrl: Urls.replaceEnv(Urls.readingApiUrl, env),
      readingGraphQLApiUrl: Urls.replaceEnv(Urls.readingGraphQLApiUrl, env) + '/v' + Urls.apiVersion.reading + '/reader/graphql',
      doolittleGraphQLApiUrl: Urls.replaceEnv(Urls.doolittleGraphQLApiUrl, env) + '/api/graphql',
      hygraphCMSApiUrl: Urls.hygraphCMSApiUrl,
      featureFlagsApiUrl: Urls.replaceEnv(Urls.flagrApiUrl, ['dev', 'test', 'rc'].includes(env) ? 'test' : env) + "v" + Urls.apiVersion.flagr,
      mppLoginUrl: Urls.replaceEnv(Urls.mppLoginUrl, env),
      fastLaneApiUrl: ((_Urls$urlsByEnvironme = Urls.urlsByEnvironment[env]) == null ? void 0 : _Urls$urlsByEnvironme.fastLaneUrl) || Urls.urlsByEnvironment[Urls.environment].fastLaneUrl,
      dsdsTokenApiUrl: Urls.replaceEnv(Urls.dsdsTokenApiUrl, env) + '/v' + Urls.apiVersion.dsdsToken + '/token',
      hygraphApiUrl: Urls.urlsByEnvironment[env].hygraphApiUrl,
      nweaUrl: Urls.nweaUrl,
      oidcPostLogoutRedirectUri: Urls.urlsByEnvironment[env].oidcPostLogoutRedirectUri,
      dsdsDashboardUrl: Urls.dsdsDashboardUrl,
      imaginePlusUrl: Urls.replaceEnv(Urls.imaginePlusUrl, env),
      myPathUrl: ((_Urls$urlsByEnvironme2 = Urls.urlsByEnvironment[env]) == null ? void 0 : _Urls$urlsByEnvironme2.myPathUrl) || Urls.urlsByEnvironment[Urls.environment].myPathUrl,
      traverseUrl: ((_Urls$urlsByEnvironme3 = Urls.urlsByEnvironment[env]) == null ? void 0 : _Urls$urlsByEnvironme3.traverseUrl) || Urls.urlsByEnvironment[Urls.environment].traverseUrl,
      robotifyUrl: ((_Urls$urlsByEnvironme4 = Urls.urlsByEnvironment[env]) == null ? void 0 : _Urls$urlsByEnvironme4.robotifyUrl) || Urls.urlsByEnvironment[Urls.environment].robotifyUrl
    };
  };
  return Urls;
}();
Urls.apiVersion = {
  api: '0.2',
  artifactApi: '2.0',
  reader: '1.0',
  report: '1.2',
  logger: '0.2',
  manager: '2.2',
  sequencer: '1.0',
  reports: '1.4',
  singleSignOn: '2.1',
  directus: '1.1',
  dsdsToken: '1',
  learnosity: '1',
  readingHeartbeat: '2.0',
  readingGraphQL: '1',
  reading: '',
  doolittleGraphQLApiUrl: '',
  hygraphCMS: '',
  flagr: '1',
  hygraph: '1'
};
// API urls
Urls.environment = 'test';
Urls.readerApiUrl = 'https://api.imaginelearning.com/report-reading';
Urls.apiUrl = 'https://api.imaginelearning.com';
Urls.loginApiUrl = 'https://manager.my.imaginelearning.com';
Urls.managementApiUrl = 'https://manager.my.imaginelearning.com';
Urls.sequencerApiUrl = 'https://sequencer.my.imaginelearning.com';
Urls.reportsApiUrl = 'https://reports.my.imaginelearning.com';
Urls.singleSignOnApiUrl = 'https://manager.my.imaginelearning.com';
Urls.importApiUrl = 'https://import.my.imaginelearning.com';
Urls.directusApiUrl = 'https://directus.imaginelearning.com';
Urls.loggerApiUrl = 'https://logger.my.imaginelearning.com';
Urls.unityLaunchUrl = 'https://my.imaginelearning.com/player';
Urls.html5ClientLaunchUrl = 'http://client.imaginelearning.com';
Urls.newHtml5ClientLaunchUrl = 'https://app.imaginelearning.com';
Urls.portalUrl = 'https://my.imaginelearning.com';
Urls.loginUrl = '/login';
Urls.readingHeartbeatApiUrl = 'https://api.imaginelearning.com/api/';
Urls.learnosityApiUrl = 'https://api.imaginelearning.com/api/';
Urls.readingApiUrl = 'https://reading.imaginelearning.com/api/';
Urls.readingGraphQLApiUrl = 'https://api.imaginelearning.com/v1/reader/graphql';
Urls.doolittleGraphQLApiUrl = 'https://reading.imaginelearning.com/api/graphql';
Urls.hygraphCMSApiUrl = 'https://api-uswest.graphcms.com/v1/cjseumkl5006001fj1pvqt0la/master';
Urls.flagrApiUrl = 'https://api.imaginelearning.com/lang-portal/api/';
Urls.mppLoginUrl = 'https://api.imaginelearning.com/signin';
Urls.dsdsTokenApiUrl = 'https://api.imaginelearning.com/sisense-proxy';
Urls.imaginePlusUrl = 'https://assessment.imaginelearning.com';
Urls.nweaUrl = 'https://sso.mapnwea.org/auth/login';
Urls.dsdsDashboardUrl = 'https://mf-root-qa.dsds.edgenuity.com/';
Urls.galileoUrls = {
  dev: 'https://aws-dev.ati-online.com/StudentCenter/ILToGalileoRedirect/Index',
  rc: 'https://galileodev.ati-online.com/StudentCenter/ILToGalileoRedirect/Index',
  prod: 'https://www.assessmenttechnology.com/StudentCenter/ILToGalileoRedirect/Index'
};
Urls.fastLaneUrls = {
  dev: 'https://api.rad.dev.edgenuityapp.com/api/graphql',
  qa: 'https://api.rad.qa.edgenuityapp.com/api/graphql',
  staging: 'https://api.rad.staging.edgenuityapp.com/api/graphql',
  prod: 'https://api-fastlane.imaginelearning.com/api/graphql' // proxy for: 'https://api.rad.edgenuity.com/api/graphql'
};
Urls.hygraphApiUrls = {
  dev: 'https://app.literacy-dev.il-apps.com/api/api-hygraph/v1/hygraph/graphql',
  qa: 'https://app.literacy-qa.il-apps.com/api/api-hygraph/v1/hygraph/graphql',
  staging: 'https://app.literacy-staging.il-apps.com/api/api-hygraph/v1/hygraph/graphql',
  prod: 'https://app.literacy-prod.il-apps.com/api/api-hygraph/v1/hygraph/graphql'
};
Urls.oidcPostLogoutRedirectUri = {
  dev: 'https://testapi.imaginelearning.com/signin',
  qa: 'https://testapi.imaginelearning.com/signin',
  staging: 'https://rcapi.imaginelearning.com/signin',
  prod: 'https://api.imaginelearning.com/signin'
};
Urls.traverseUrls = {
  dev: 'https://app.traverse-test.com/api/il-launch',
  qa: 'https://app.traverse-test.com/api/il-launch',
  staging: 'https://app.traverse-staging.com/api/il-launch',
  prod: 'https://learn.traverse-app.com/api/il-launch'
};
Urls.myPathUrls = {
  dev: 'https://app.dev.edgenuityapp.com/launch',
  qa: 'https://app.qa.edgenuityapp.com/launch',
  staging: 'https://app.staging.edgenuityapp.com/launch',
  prod: 'https://app.edgenuity.com/launch'
};
Urls.robotifyUrls = {
  dev: 'https://robotify.robo-dev.il-consumer.com/oauth/initiate_readiness_sso',
  qa: 'https://robotify.robo-dev.il-consumer.com/oauth/initiate_readiness_sso',
  staging: 'https://robotify.robo-staging.il-consumer.com/oauth/initiate_readiness_sso',
  prod: 'https://edu.robotify.com/oauth/initiate_readiness_sso'
};
Urls.urlsByEnvironment = {
  dev: {
    fastLaneUrl: Urls.fastLaneUrls.qa,
    galileoUrl: Urls.galileoUrls.dev,
    hygraphApiUrl: Urls.hygraphApiUrls.dev,
    oidcPostLogoutRedirectUri: Urls.oidcPostLogoutRedirectUri.dev,
    myPathUrl: Urls.myPathUrls.dev,
    traverseUrl: Urls.traverseUrls.dev,
    robotifyUrl: Urls.robotifyUrls.dev
  },
  test: {
    fastLaneUrl: Urls.fastLaneUrls.qa,
    galileoUrl: Urls.galileoUrls.dev,
    hygraphApiUrl: Urls.hygraphApiUrls.qa,
    oidcPostLogoutRedirectUri: Urls.oidcPostLogoutRedirectUri.qa,
    myPathUrl: Urls.myPathUrls.qa,
    traverseUrl: Urls.traverseUrls.qa,
    robotifyUrl: Urls.robotifyUrls.qa
  },
  load: {
    fastLaneUrl: Urls.fastLaneUrls.qa,
    galileoUrl: Urls.galileoUrls.dev,
    hygraphApiUrl: Urls.hygraphApiUrls.qa,
    oidcPostLogoutRedirectUri: Urls.oidcPostLogoutRedirectUri.qa
  },
  rc: {
    fastLaneUrl: Urls.fastLaneUrls.staging,
    galileoUrl: Urls.galileoUrls.rc,
    hygraphApiUrl: Urls.hygraphApiUrls.staging,
    oidcPostLogoutRedirectUri: Urls.oidcPostLogoutRedirectUri.staging,
    myPathUrl: Urls.myPathUrls.staging,
    traverseUrl: Urls.traverseUrls.staging,
    robotifyUrl: Urls.robotifyUrls.staging
  },
  prod: {
    fastLaneUrl: Urls.fastLaneUrls.prod,
    galileoUrl: Urls.galileoUrls.prod,
    hygraphApiUrl: Urls.hygraphApiUrls.prod,
    oidcPostLogoutRedirectUri: Urls.oidcPostLogoutRedirectUri.prod,
    myPathUrl: Urls.myPathUrls.prod,
    traverseUrl: Urls.traverseUrls.prod,
    robotifyUrl: Urls.robotifyUrls.prod
  }
};

function accessTokenFromApiConfig(apiConfig) {
  return typeof apiConfig.accessToken === 'function' ? apiConfig.accessToken() : apiConfig.accessToken;
}
function authJwtFromApiConfig(apiConfig) {
  return new AuthJwt(accessTokenFromApiConfig(apiConfig));
}

var FIVE_MINUTES_IN_MS = 1000 * 60 * 5; // 1000 ms * 60 * 5 = 5 minutes
var CacheService = /*#__PURE__*/function () {
  function CacheService(items) {
    if (items === void 0) {
      items = [];
    }
    this.items = items;
    this.maxItems = 100;
    this.timeout = FIVE_MINUTES_IN_MS;
  }
  var _proto = CacheService.prototype;
  _proto.add = function add(item) {
    if (this.items.length >= this.maxItems) {
      this.items.shift();
    }
    this.items.push(item);
  };
  _proto.get = function get(predicate) {
    var index = this.items.findIndex(predicate);
    var item = this.items[index];
    var now = Date.now();
    if (!item) {
      return undefined;
    }
    if (now - item.created >= this.timeout) {
      this.items.splice(index, 1);
      return undefined;
    }
    return item;
  };
  _proto.remove = function remove(predicate) {
    var index = this.items.findIndex(predicate);
    if (index >= 0) {
      this.items.splice(index, 1);
    }
  };
  _proto.clear = function clear() {
    this.items = [];
  };
  return CacheService;
}();
function cache(items) {
  return new CacheService(items);
}

var CachedRequestItem = function CachedRequestItem(url, params, response) {
  this.url = url;
  this.params = params;
  this.response = response;
  this.created = new Date().getTime();
};

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}

var Helpers = /*#__PURE__*/function () {
  function Helpers() {}
  // remove any undefined params from request params
  Helpers.sanitizeParams = function sanitizeParams(params) {
    var sanitized = Object.assign({}, params);
    Object.keys(sanitized).forEach(function (key) {
      return sanitized[key] === undefined && delete sanitized[key];
    });
    return sanitized;
  };
  return Helpers;
}();

var ErrorMessages = /*#__PURE__*/function () {
  function ErrorMessages() {}
  ErrorMessages.getHumanReadable = function getHumanReadable(error) {
    if (isEmpty(error)) {
      return undefined;
    }
    var expression, match, regex;
    for (var prop in ErrorMessages.expressions) {
      if (expression = ErrorMessages.expressions[prop]) {
        regex = new RegExp(expression.regex);
        if (match = error.match(regex)) {
          break;
        }
      }
    }
    return match && regex ? match[0].replace(regex, expression.replacement) : undefined;
  };
  return ErrorMessages;
}();
ErrorMessages.expressions = {
  duplicateKey: {
    regex: '(?<field>[{}\\w\\-]+)\\[(?<value>[^\\]]+)\\]\\scauses\\sduplicate\\skey',
    replacement: '$2 already exists for $1. Enter a different value for $1.'
  },
  stringLengthOutOfRange: {
    regex: '(?<field>[{}\\w\\-]+)\\[(?<value>[^\\]]+)\\]\\sstring\\slength\\sout\\sof\\srange\\s\\((?<min>\\d+)\\-(?<max>\\d+)\\)',
    replacement: '$2 is not a valid $1. $1 must be between $3 and $4 characters long.'
  },
  incorrectCase: {
    regex: '(?<field>[{}\\w\\-]+)\\[(?<value>[^\\]]+)\\]\\sstring\\snot\\s(?<case>Lowercase|Uppercase)',
    replacement: '$2 is not a valid $1. $1 must be $3.'
  },
  notEmail: {
    regex: '(?<field>[{}\\w\\-]+)\\[(?<value>[^\\]]+)\\]\\snot\\sin\\sa\\svalid\\semail\\saddress\\sformat',
    replacement: '$2 is not a valid $1. $1 must follow this format: username@domain.edu'
  },
  required: {
    regex: '(?<field>[{}\\w\\-]+)\\sis\\srequired.',
    replacement: '$1 is a required field. Enter a valid $1.'
  },
  empty: {
    regex: '(?<field>[{}\\w\\-]+)\\scannot\\sbe\\sempty',
    replacement: '$1 cannot be empty. Enter a valid $1.'
  },
  containsDuplicates: {
    regex: '(?<field>[{}\\w\\-]+)\\[(?<value>[^\\]]+)\\]\\scannot\\scontain\\sduplicates',
    replacement: '$1 has duplicate values. All values in $1 must be unique. Remove any duplicates.'
  },
  doesNotExist: {
    regex: '(?<field>[{}\\w\\-]+)\\[(?<value>[^\\]]+)\\]\\sdoes\\snot\\sexist',
    replacement: '$2 is not a valid $1. $2 does not exist for $1.'
  },
  membership: {
    regex: '(?<field>[{}\\w\\-]+)\\[(?<value>[^\\]]+)\\]\\sdo\\snot\\sbelong\\sto\\sany\\s(?<membership>[\\w\\-]+)\\sthat\\sthe\\s(?<typeName>[\\w\\-]+)\\sbelongs\\sto',
    replacement: "The $2 group does not exist in this $4's $3."
  },
  nullValue: {
    regex: '(?<field>[{}\\w\\-]+)\\[(?<value>[^\\]]+)\\]\\scannot\\scontain\\snull\\svalues',
    replacement: "$1 is required and can't be left blank."
  },
  outOfRange: {
    regex: '(?<field>[{}\\w\\-]+)\\[(?<value>[^\\]]+)\\]\\sout\\sof\\srange\\s\\((?<min>\\d+)\\-(?<max>\\d+)\\)',
    replacement: '$2 is not a valid $1. $1 must be between $3 and $4.'
  },
  timeout: {
    regex: 'timeout error',
    replacement: 'Your request timed out.'
  },
  duplicateIndexKey: {
    regex: 'DuplicateKey:\\sindex:\\s(?<field>[\\w\\-]+)\\sdup\\skey:\\s{\\s:\\s"(?<value>[^"]+)"\\s\\}',
    replacement: 'This $1 is already taken. Enter a different $1.'
  },
  multipleSiteCodes: {
    regex: 'AuthUser\\s(?<field>[\\w\\-]+)\\sis\\sinvalid\\s-\\sa\\sstudent\\scannot\\sbelong\\sto\\smore\\sthan\\sone\\ssite',
    replacement: 'A student cannot be assigned to more than one Site Code.'
  },
  invalidSiteCode: {
    regex: 'AuthUser\\s\\((?<field>[\\w\\-]+)\\)\\sis\\sinvalid\\s-\\sno\\sorganization\\shas\\sthat\\ssitecode',
    replacement: 'An organization with this $1 does not exist.'
  },
  usernameNotMatch: {
    regex: 'AuthUser\\s\\((?<username>[\\w\\-]+)\\)\\sdoes\\snot\\smatch\\sStudent\\susername\\s\\((?<studentUsername>[\\w\\-]+)\\)',
    replacement: 'AuthUser $1 and Student username $2 do not match.'
  },
  studentHasNoORganization: {
    regex: 'Organizations Student must belong to at least one organization.',
    replacement: 'Student must be assigned to at least one organization.'
  }
};

function getDetailedResult(result) {
  return {
    id: result == null ? void 0 : result.id,
    status: result == null ? void 0 : result.status,
    errorDetails: result == null ? void 0 : result.errorDetails,
    error: !!(result != null && result.error) ? ErrorMessages.getHumanReadable(result.error) || result.error : ErrorMessages.getHumanReadable(result == null ? void 0 : result.errorDetails) || (result == null ? void 0 : result.errorDetails)
  };
}
function authInterceptor(apiConfig) {
  return function (config) {
    var headers = _extends({}, config.headers, {
      Authorization: "bearer " + apiConfig.accessToken
    });
    return _extends({}, config, {
      headers: headers
    });
  };
}
function errorMessageInterceptor() {
  return function (response) {
    if (response.data && (response.data.error || response.data.errorDetails)) {
      response.data.error = response.data.error ? ErrorMessages.getHumanReadable(response.data.error) || response.data.error : ErrorMessages.getHumanReadable(response.data.errorDetails) || response.data.errorDetails;
    }
    if (response.data && response.data.results && response.data.results.length > 0) {
      response.data.results = response.data.results.map(function (result) {
        return result.errorDetails ? getDetailedResult(result) : result;
      });
    }
    return response;
  };
}
function errorMessageTransform(response) {
  if (response.data && (response.data.error || response.data.errorDetails)) {
    response.data.error = response.data.error ? ErrorMessages.getHumanReadable(response.data.error) || response.data.error : ErrorMessages.getHumanReadable(response.data.errorDetails) || response.data.errorDetails;
  }
  if (response.data && response.data.results && response.data.results.length > 0) {
    response.data.results = response.data.results.map(function (result) {
      return result.errorDetails ? getDetailedResult(result) : result;
    });
  }
  return response;
}

var HttpRxClient = /*#__PURE__*/function () {
  function HttpRxClient(apiConfig) {
    this.apiConfig = apiConfig;
  }
  var _proto = HttpRxClient.prototype;
  _proto.get = function get(url, params) {
    if (params === void 0) {
      params = {};
    }
    var queryParams = Helpers.sanitizeParams(_extends({}, params));
    return http(url).bearer(accessTokenFromApiConfig(this.apiConfig)).query(_extends({}, queryParams)).errorTransform(errorMessageTransform).get().pipe(map(function (response) {
      return response;
    }));
  };
  _proto.post = function post(url, body) {
    if (body === void 0) {
      body = {};
    }
    return http(url).bearer(accessTokenFromApiConfig(this.apiConfig)).body(body).errorTransform(errorMessageTransform).post().pipe(map(function (response) {
      return response;
    }));
  };
  _proto.put = function put(url, body) {
    if (body === void 0) {
      body = {};
    }
    return http(url).bearer(accessTokenFromApiConfig(this.apiConfig)).body(body).errorTransform(errorMessageTransform).put().pipe(map(function (response) {
      return response;
    }));
  };
  _proto.patch = function patch(url, body) {
    if (body === void 0) {
      body = {};
    }
    return http(url).bearer(accessTokenFromApiConfig(this.apiConfig)).body(body).errorTransform(errorMessageTransform).patch().pipe(map(function (response) {
      return response;
    }));
  };
  _proto["delete"] = function _delete(url) {
    return http(url).bearer(accessTokenFromApiConfig(this.apiConfig)).errorTransform(errorMessageTransform)["delete"]();
  };
  return HttpRxClient;
}();

var CachedRequestService = /*#__PURE__*/function () {
  function CachedRequestService(apiConfig) {
    this.apiConfig = apiConfig;
    this.http = new HttpRxClient(this.apiConfig);
  }
  var _proto = CachedRequestService.prototype;
  _proto.get = function get(url, params) {
    var _this$apiConfig$reque,
      _this = this;
    var request = (_this$apiConfig$reque = this.apiConfig.requestCache) == null ? void 0 : _this$apiConfig$reque.get(function (item) {
      return item.url === url && isEqual(item.params, params);
    });
    return request ? of(request.response) : this.http.get(url, params).pipe(tap(function (response) {
      var _this$apiConfig$reque2;
      (_this$apiConfig$reque2 = _this.apiConfig.requestCache) == null ? void 0 : _this$apiConfig$reque2.add(new CachedRequestItem(url, params, response));
    }));
  };
  _proto.post = function post(url, params) {
    var _this$apiConfig$reque3,
      _this2 = this;
    var request = (_this$apiConfig$reque3 = this.apiConfig.requestCache) == null ? void 0 : _this$apiConfig$reque3.get(function (item) {
      return item.url === url && isEqual(item.params, params);
    });
    return request ? of(request.response) : this.http.post(url, params).pipe(tap(function (response) {
      var _this2$apiConfig$requ;
      (_this2$apiConfig$requ = _this2.apiConfig.requestCache) == null ? void 0 : _this2$apiConfig$requ.add(new CachedRequestItem(url, params, response));
    }));
  };
  return CachedRequestService;
}();

var Environment = function Environment() {};

// Grade Levels from API
var API_GRADE_LEVELS;
(function (API_GRADE_LEVELS) {
  API_GRADE_LEVELS["PreK"] = "PreK";
  API_GRADE_LEVELS["Kindergarten"] = "Kindergarten";
  API_GRADE_LEVELS["First"] = "First";
  API_GRADE_LEVELS["Second"] = "Second";
  API_GRADE_LEVELS["Third"] = "Third";
  API_GRADE_LEVELS["Fourth"] = "Fourth";
  API_GRADE_LEVELS["Fifth"] = "Fifth";
  API_GRADE_LEVELS["Sixth"] = "Sixth";
  API_GRADE_LEVELS["Seventh"] = "Seventh";
  API_GRADE_LEVELS["Eighth"] = "Eighth";
  API_GRADE_LEVELS["Ninth"] = "Ninth";
  API_GRADE_LEVELS["Tenth"] = "Tenth";
  API_GRADE_LEVELS["Eleventh"] = "Eleventh";
  API_GRADE_LEVELS["Twelfth"] = "Twelfth";
  API_GRADE_LEVELS["Other"] = "Other";
  API_GRADE_LEVELS["All"] = "All";
})(API_GRADE_LEVELS || (API_GRADE_LEVELS = {}));
// Grade Levels from API with user facing names
var GRADE_LEVELS;
(function (GRADE_LEVELS) {
  GRADE_LEVELS["PreK"] = "Pre-K";
  GRADE_LEVELS["Kindergarten"] = "K";
  GRADE_LEVELS["First"] = "Grade 1";
  GRADE_LEVELS["Second"] = "Grade 2";
  GRADE_LEVELS["Third"] = "Grade 3";
  GRADE_LEVELS["Fourth"] = "Grade 4";
  GRADE_LEVELS["Fifth"] = "Grade 5";
  GRADE_LEVELS["Sixth"] = "Grade 6";
  GRADE_LEVELS["Seventh"] = "Grade 7";
  GRADE_LEVELS["Eighth"] = "Grade 8";
  GRADE_LEVELS["Ninth"] = "Grade 9";
  GRADE_LEVELS["Tenth"] = "Grade 10";
  GRADE_LEVELS["Eleventh"] = "Grade 11";
  GRADE_LEVELS["Twelfth"] = "Grade 12";
  GRADE_LEVELS["Other"] = "Other";
  GRADE_LEVELS["All"] = "All";
})(GRADE_LEVELS || (GRADE_LEVELS = {}));
// Grade Levels from API used in the UI
var GRADE_LEVEL_OPTIONS;
(function (GRADE_LEVEL_OPTIONS) {
  GRADE_LEVEL_OPTIONS["PreK"] = "Pre-K";
  GRADE_LEVEL_OPTIONS["Kindergarten"] = "K";
  GRADE_LEVEL_OPTIONS["First"] = "Grade 1";
  GRADE_LEVEL_OPTIONS["Second"] = "Grade 2";
  GRADE_LEVEL_OPTIONS["Third"] = "Grade 3";
  GRADE_LEVEL_OPTIONS["Fourth"] = "Grade 4";
  GRADE_LEVEL_OPTIONS["Fifth"] = "Grade 5";
  GRADE_LEVEL_OPTIONS["Sixth"] = "Grade 6";
  GRADE_LEVEL_OPTIONS["Seventh"] = "Grade 7";
  GRADE_LEVEL_OPTIONS["Eighth"] = "Grade 8";
  GRADE_LEVEL_OPTIONS["Ninth"] = "Grade 9";
  GRADE_LEVEL_OPTIONS["Tenth"] = "Grade 10";
  GRADE_LEVEL_OPTIONS["Eleventh"] = "Grade 11";
  GRADE_LEVEL_OPTIONS["Twelfth"] = "Grade 12";
})(GRADE_LEVEL_OPTIONS || (GRADE_LEVEL_OPTIONS = {}));
var coreGradeLevels = [{
  key: API_GRADE_LEVELS.PreK,
  value: GRADE_LEVELS.PreK,
  sort: 1
}, {
  key: API_GRADE_LEVELS.Kindergarten,
  value: GRADE_LEVELS.Kindergarten,
  sort: 2
}, {
  key: API_GRADE_LEVELS.First,
  value: GRADE_LEVELS.First,
  sort: 3
}, {
  key: API_GRADE_LEVELS.Second,
  value: GRADE_LEVELS.Second,
  sort: 4
}, {
  key: API_GRADE_LEVELS.Third,
  value: GRADE_LEVELS.Third,
  sort: 5
}, {
  key: API_GRADE_LEVELS.Fourth,
  value: GRADE_LEVELS.Fourth,
  sort: 6
}, {
  key: API_GRADE_LEVELS.Fifth,
  value: GRADE_LEVELS.Fifth,
  sort: 7
}, {
  key: API_GRADE_LEVELS.Sixth,
  value: GRADE_LEVELS.Sixth,
  sort: 8
}, {
  key: API_GRADE_LEVELS.Seventh,
  value: GRADE_LEVELS.Seventh,
  sort: 9
}, {
  key: API_GRADE_LEVELS.Eighth,
  value: GRADE_LEVELS.Eighth,
  sort: 10
}, {
  key: API_GRADE_LEVELS.Ninth,
  value: GRADE_LEVELS.Ninth,
  sort: 11
}, {
  key: API_GRADE_LEVELS.Tenth,
  value: GRADE_LEVELS.Tenth,
  sort: 12
}, {
  key: API_GRADE_LEVELS.Eleventh,
  value: GRADE_LEVELS.Eleventh,
  sort: 13
}, {
  key: API_GRADE_LEVELS.Twelfth,
  value: GRADE_LEVELS.Twelfth,
  sort: 14
}];
var GradeLevels = /*#__PURE__*/function () {
  function GradeLevels() {}
  GradeLevels.fromApiGradeLevel = function fromApiGradeLevel(gradeLevel) {
    return gradeLevel === API_GRADE_LEVELS.All ? gradeLevel : GRADE_LEVELS[gradeLevel];
  };
  GradeLevels.toApiGradeLevel = function toApiGradeLevel(gradeLevel) {
    var apiGrade = this.AllGradeLevels.find(function (grade) {
      return grade.value === gradeLevel;
    });
    return apiGrade.key;
  };
  GradeLevels.sort = function sort(a, b) {
    var gradelevels = GradeLevels.AllGradeLevels;
    var gradeLevelA = !!a && a.length ? gradelevels.find(function (grade) {
      return grade.key === a;
    }) : undefined;
    var gradeLevelB = !!b && b.length ? gradelevels.find(function (grade) {
      return grade.key === b;
    }) : undefined;
    var valueA = gradeLevelA ? gradeLevelA.sort : 16;
    var valueB = gradeLevelB ? gradeLevelB.sort : 16;
    return valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
  };
  _createClass(GradeLevels, null, [{
    key: "APIGradeLevels",
    get:
    // Returns all grade levels from the Registration API enum
    function get() {
      return [].concat(coreGradeLevels, [{
        key: API_GRADE_LEVELS.Other,
        value: GRADE_LEVELS.Other,
        sort: 15
      }]);
    }
    // Returns grade levels for drop downs allowing selection of which grade level a student is in. Does not include the option 'All'
  }, {
    key: "GradeLevelOptions",
    get: function get() {
      return [].concat(coreGradeLevels);
    }
    // Returns grade levels for report filtering. Includes the option 'All'
  }, {
    key: "UIGradeLevels",
    get: function get() {
      return [].concat(coreGradeLevels, [{
        key: API_GRADE_LEVELS.All,
        value: GRADE_LEVELS.All,
        sort: 15
      }]);
    }
    // Returns all grade levels from the Registration API enum and adds the 'All' option
  }, {
    key: "AllGradeLevels",
    get: function get() {
      return [].concat(coreGradeLevels, [{
        key: API_GRADE_LEVELS.Other,
        value: GRADE_LEVELS.Other,
        sort: 15
      }, {
        key: API_GRADE_LEVELS.All,
        value: GRADE_LEVELS.All,
        sort: 16
      }]);
    }
  }]);
  return GradeLevels;
}();

var HttpRxClientMock = /*#__PURE__*/function () {
  function HttpRxClientMock(apiConfig) {
    this.url = '';
    this.status = 200;
    this.apiConfig = apiConfig;
  }
  var _proto = HttpRxClientMock.prototype;
  _proto.get = function get(url, params) {
    if (params === void 0) {
      params = {};
    }
    this.url = url;
    this.params = params;
    return of({
      data: this.data,
      headers: this.headers,
      status: this.status
    });
  };
  _proto.post = function post(url, body) {
    if (body === void 0) {
      body = {};
    }
    this.url = url;
    this.body = body;
    return of({
      data: this.data,
      headers: this.headers,
      status: this.status
    });
  };
  _proto.put = function put(url, body) {
    if (body === void 0) {
      body = {};
    }
    this.url = url;
    this.body = body;
    return of({
      data: this.data,
      headers: this.headers,
      status: this.status
    });
  };
  _proto.patch = function patch(url, body) {
    if (body === void 0) {
      body = {};
    }
    this.url = url;
    this.body = body;
    return of({
      data: this.data,
      headers: this.headers,
      status: this.status
    });
  };
  _proto["delete"] = function _delete(url) {
    this.url = url;
    return of({
      data: this.data,
      headers: this.headers,
      status: this.status
    });
  };
  return HttpRxClientMock;
}();

var Product;
(function (Product) {
  Product["ILE"] = "Imagine Language & Literacy";
  Product["Spanish"] = "Imagine Espa\xF1ol";
  Product["Enyay"] = "Imagine Lectura";
  Product["Lectura"] = "Imagine Lectura";
  Product["Reader"] = "Imagine Reading";
  Product["IM"] = "Imagine Math";
  Product["IMF"] = "Imagine Math Facts";
  Product["Galileo"] = "Imagine Assessment: Galileo";
  Product["MyPathMath"] = "Imagine MyPath Math";
  Product["MyPathReading"] = "Imagine MyPath Reading";
  Product["Science"] = "Imagine Science Corner";
  Product["Purpose"] = "Imagine Purpose";
  Product["Traverse"] = "Imagine Traverse";
  Product["Robotify"] = "Imagine Robotify";
  Product["IPA"] = "Imagine+ Assessment";
  Product["DrSeuss"] = "Seuss Corner";
  Product["Other"] = "Other";
  Product["None"] = "None";
  Product["Any"] = "Any";
})(Product || (Product = {}));
var ProductShortName;
(function (ProductShortName) {
  ProductShortName["ILE"] = "L&L";
  ProductShortName["Spanish"] = "Espa\xF1ol";
  ProductShortName["Enyay"] = "Lectura";
  ProductShortName["Lectura"] = "Lectura";
  ProductShortName["Reader"] = "Reading";
  ProductShortName["IM"] = "Math";
  ProductShortName["IMF"] = "Math Facts";
  ProductShortName["Galileo"] = "Galileo";
  ProductShortName["MyPathMath"] = "MyPath Math";
  ProductShortName["MyPathReading"] = "MyPath Reading";
  ProductShortName["Science"] = "Science Corner";
  ProductShortName["Purpose"] = "Purpose";
  ProductShortName["Traverse"] = "Traverse";
  ProductShortName["Robotify"] = "Robotify";
  ProductShortName["IPA"] = "Imagine+ Assessment";
  ProductShortName["DrSeuss"] = "Seuss Corner";
  ProductShortName["Other"] = "Other";
  ProductShortName["None"] = "None";
  ProductShortName["Any"] = "Any";
})(ProductShortName || (ProductShortName = {}));
var ApiProduct;
(function (ApiProduct) {
  ApiProduct["ILE"] = "ILE";
  ApiProduct["Spanish"] = "Spanish";
  ApiProduct["Enyay"] = "Enyay";
  ApiProduct["Lectura"] = "Lectura";
  ApiProduct["Reader"] = "Reader";
  ApiProduct["IM"] = "IM";
  ApiProduct["IMF"] = "IMF";
  ApiProduct["Galileo"] = "Galileo";
  ApiProduct["MyPathMath"] = "MyPathMath";
  ApiProduct["MyPathReading"] = "MyPathReading";
  ApiProduct["Science"] = "Science";
  ApiProduct["Purpose"] = "Purpose";
  ApiProduct["Traverse"] = "Traverse";
  ApiProduct["Robotify"] = "Robotify";
  ApiProduct["IPA"] = "IPA";
  ApiProduct["DrSeuss"] = "DrSeuss";
  ApiProduct["Other"] = "Other";
  ApiProduct["None"] = "None";
  ApiProduct["Any"] = "Any";
})(ApiProduct || (ApiProduct = {}));
var DefaultAssignedProducts = ['ILE', 'Spanish', 'Lectura', 'Reader', 'Galileo', 'MyPathMath', 'MyPathReading', 'Science', 'Purpose', 'Traverse'];
/**
 * languages can either be a string or an array, the string can only be the character '*' which means all available languages.
 * In case an array is present, only the languages in the array are considered to be available for the product
 * In case languages is not present, it is considered as if the product doesn't have language settings
 * @dynamic
 */
var Products = /*#__PURE__*/function () {
  function Products() {}
  Products.getLanguageList = function getLanguageList(productCode, languages) {
    var product = Products.apiProducts.find(function (x) {
      return x.value === productCode;
    });
    if (product && product.languages) {
      if (product.languages === '*') {
        return languages.sort();
      } else if (Array.isArray(product.languages)) {
        return product.languages.sort();
      } else {
        return [];
      }
    } else {
      return [];
    }
  };
  _createClass(Products, null, [{
    key: "apiProducts",
    get: function get() {
      return [{
        id: 0,
        value: ApiProduct.ILE,
        name: Product.ILE,
        shortName: ProductShortName.ILE,
        languages: '*',
        defaultLanguage: 'English'
      }, {
        id: 1,
        value: ApiProduct.Spanish,
        name: Product.Spanish,
        shortName: ProductShortName.Spanish,
        languages: ['Spanish', 'English'],
        defaultLanguage: 'Spanish'
      }, {
        id: 2,
        value: ApiProduct.IM,
        name: Product.IM,
        shortName: ProductShortName.IM
      }, {
        id: 3,
        value: ApiProduct.IMF,
        name: Product.IMF,
        shortName: ProductShortName.IMF
      }, {
        id: 4,
        value: ApiProduct.Reader,
        name: Product.Reader,
        shortName: ProductShortName.Reader
      }, {
        id: 5,
        value: ApiProduct.Galileo,
        name: Product.Galileo,
        shortName: ProductShortName.Galileo
      }, {
        id: 6,
        value: ApiProduct.Enyay,
        name: Product.Enyay,
        shortName: ProductShortName.Enyay,
        languages: ['Spanish', 'English'],
        defaultLanguage: 'Spanish'
      }, {
        id: 7,
        value: ApiProduct.Lectura,
        name: Product.Lectura,
        shortName: ProductShortName.Lectura,
        languages: ['Spanish', 'English'],
        defaultLanguage: 'Spanish'
      }, {
        id: 8,
        value: ApiProduct.MyPathMath,
        name: Product.MyPathMath,
        shortName: ProductShortName.MyPathMath
      }, {
        id: 9,
        value: ApiProduct.MyPathReading,
        name: Product.MyPathReading,
        shortName: ProductShortName.MyPathReading
      }, {
        id: 10,
        value: ApiProduct.Science,
        name: Product.Science,
        shortName: ProductShortName.Science
      }, {
        id: 11,
        value: ApiProduct.Purpose,
        name: Product.Purpose,
        shortName: ProductShortName.Purpose
      }, {
        id: 12,
        value: ApiProduct.Traverse,
        name: Product.Traverse,
        shortName: ProductShortName.Traverse
      }, {
        id: 13,
        value: ApiProduct.Robotify,
        name: Product.Robotify,
        shortName: ProductShortName.Robotify
      }, {
        id: 14,
        value: ApiProduct.IPA,
        name: Product.IPA,
        shortName: ProductShortName.IPA
      }, {
        id: 15,
        value: ApiProduct.DrSeuss,
        name: Product.DrSeuss,
        shortName: ProductShortName.DrSeuss
      }];
    }
  }]);
  return Products;
}();

var CookieStorage = /*#__PURE__*/function () {
  function CookieStorage(cookies) {
    this.cookies = cookies;
  }
  var _proto = CookieStorage.prototype;
  _proto.setItem = function setItem(key, value) {
    this.cookies.set(key, JSON.stringify(value));
  };
  _proto.getItem = function getItem(key) {
    return JSON.parse(this.cookies.get(key));
  };
  _proto.removeItem = function removeItem(key) {
    this.cookies.remove(key);
  };
  _proto.clear = function clear() {
    var _this = this;
    // Read all visible cookies
    var cookies = this.cookies.get();
    if (cookies) {
      // Iterate through and remove each one
      Object.keys(cookies).forEach(function (cookie) {
        return _this.cookies.remove(cookie);
      });
    }
  };
  return CookieStorage;
}();
var CookieStorageService = /*#__PURE__*/new CookieStorage(Cookies);

var WebStorage = /*#__PURE__*/function () {
  function WebStorage(storage, alternateStorage) {
    this.isAlternateStorage = false;
    this.store = storage;
    if (!this.store) {
      this.isAlternateStorage = true;
      this.store = alternateStorage;
    }
  }
  var _proto = WebStorage.prototype;
  _proto.setItem = function setItem(key, value) {
    var val = this.isAlternateStorage ? value : JSON.stringify(value);
    this.store.setItem(key, val);
  };
  _proto.getItem = function getItem(key) {
    var item = this.store.getItem(key);
    return this.isAlternateStorage ? item : JSON.parse(item);
  };
  _proto.removeItem = function removeItem(key) {
    this.store.removeItem(key);
  };
  _proto.clear = function clear() {
    this.store.clear();
  };
  return WebStorage;
}();
var SessionStorageService = /*#__PURE__*/new WebStorage(window.sessionStorage, CookieStorageService);
var LocalStorageService = /*#__PURE__*/new WebStorage(window.localStorage, CookieStorageService);

export { API_GRADE_LEVELS, ApiProduct, CacheService, CachedRequestItem, CachedRequestService, CookieStorage, CookieStorageService, DefaultAssignedProducts, Environment, ErrorMessages, GRADE_LEVELS, GRADE_LEVEL_OPTIONS, GradeLevels, Helpers, HttpRxClient, HttpRxClientMock, LocalStorageService, Product, ProductShortName, Products, SessionStorageService, Urls, WebStorage, accessTokenFromApiConfig, authInterceptor, authJwtFromApiConfig, cache, errorMessageInterceptor, errorMessageTransform };
//# sourceMappingURL=web-api-core.esm.js.map
